// src/data/huiyi.ts
export interface Meeting {
  name: string;
  address: string;
  time: string;
  url: string;
}

export const meetings: Meeting[] = [
  {
    name: "神经免疫分会2025年学术会议",
    address: "济宁富力万达嘉华酒店",
    time: "2025-08-16",
    url: "https://s.31url.cn/bjvCYnJA"
  },
  {
    name: "脑血管病分会成立大会暨山东省脑卒中大会",
    address: "济南银丰华美达酒店",
    time: "2025-08-22",
    url: "https://my.31huiyi.com/pc/page/605d0000-2776-c61f-d761-08ddc8b0a7b7?theme=light"
  },
  {
    name: "重症脑血管病分会成立大会暨山东省脑卒中大会",
    address: "济南银丰华美达酒店",
    time: "2025-08-22",
    url: "https://s.31url.cn/YnJ0GjvC"
  },
  {
    name: "山东省神经科学学会神经康复分会第二次学术年会暨第七届山东省认知语言障碍康复培训班",
    address: "济南银座佳悦酒店",
    time: "2025-09-26",
    url: "https://s.31url.cn/Ywy9FjvC"
  },
    {
    name: "山东省神经科学学会神经重症分会成立大会暨首届神经重症医学大会",
    address: "济南鲁能贵和洲际酒店",
    time: "2025-10-31",
    url: "https://s.31url.cn/wjvCYQHK"
  },
  {
    name: "睡眠障碍规范化诊疗及新技术推广系列活动启动仪式暨嗜睡诊疗新进展专题会",
    address: "山东省泰山医院",
    time: "2025-09-27",
    url: "https://s.31url.cn/QSoEjvCY"
  },
  {
    name: "山东省神经科学学会老年医学分会成立大会暨第一次学术会议",
    address: "济南阳光壹佰雅高美爵酒店",
    time: "2025-11-07",
    url: "https://s.31url.cn/PiBjvCY6"
  },
  {
    name: "山东省神经科学学会神经外科学分会2025年度学术年会",
    address: "临沂沂河宾馆",
    time: "2025-11-21",
    url: "https://s.31url.cn/SBjvCYHm"
  },
  {
    name: "山东省神经科学学会脑机接口与神经修复分会成立大会暨首届脑机接口与神经修复学术年会",
    address: "临沂沂河宾馆",
    time: "2025-11-21",
    url: "https://s.31url.cn/IjvCYHDv"
  },
  // {
  //   name: "山东省神经科学学会帕金森病与运动障碍专业委员会成立大会暨首届帕金森病与运动障碍新进展学术论坛",
  //   address: "济南阳光壹佰雅高美爵酒店",
  //   time: "2025-12-05",
  //   url: "https://s.31url.cn/9a9jvCY6"
  // },
  // 可以继续添加更多会议...
];

// 获取所有会议（按时间倒序排列 - 最新的在前面）
export const getAllMeetings = (): Meeting[] => {
  return [...meetings].sort((a, b) => new Date(b.time).getTime() - new Date(a.time).getTime());
};

// 获取最新的会议（用于首页显示）
export const getLatestMeetings = (limit = 5): Meeting[] => {
  return getAllMeetings().slice(0, limit);
};